export type ImportAction = "validate" | "resolve_addresses" | "import";

export const useImportActions = (
  importFunction: (formData: FormData, action: ImportAction) => Promise<any>,
  invertMapping: () => Record<string, string>,
  file: File | null,
  setUploading: (b: boolean) => void,
  setValidation: (v: any) => void,
  setImportResult: (r: any) => void,

  // ✅ NEW: store resolution results for the Verify step
  setAddressResolution: (v: any) => void,

  // ✅ NEW: provide latest overrides at import time
  getAddressOverrides: () => Record<string, any>
) => {
  const buildFormData = () => {
    if (!file) return null;

    const fd = new FormData();
    fd.append("file", file);
    fd.append("mapping", JSON.stringify(invertMapping()));
    return fd;
  };

  const validateFile = async () => {
    if (!file) return alert("Please upload a file first");

    setUploading(true);
    try {
      const fd = buildFormData();
      if (!fd) return;

      const result = await importFunction(fd, "validate");
      setValidation(result);
      return result;
    } finally {
      setUploading(false);
    }
  };

  // ✅ NEW: resolve address candidates for the Verify Addresses step
  const resolveAddresses = async () => {
    if (!file) return alert("Please upload a file first");

    setUploading(true);
    try {
      const fd = buildFormData();
      if (!fd) return;

      const result = await importFunction(fd, "resolve_addresses");
      setAddressResolution(result);
      return result;
    } finally {
      setUploading(false);
    }
  };

  const importFile = async () => {
    if (!file) return alert("No file to import");

    setUploading(true);
    try {
      const fd = buildFormData();
      if (!fd) return;

      // ✅ NEW: send address overrides chosen during Verify step
      fd.append("address_overrides", JSON.stringify(getAddressOverrides() || {}));

      const result = await importFunction(fd, "import");
      setImportResult(result);
      return result;
    } finally {
      setUploading(false);
    }
  };

  return { validateFile, resolveAddresses, importFile };
};